import React from 'react';
import moment from 'moment';
import { t } from '../multi-language/multi-lang.service';
function AnnotationsList(_a) {
    var annotations = _a.annotations;
    if (!annotations.length)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: 'wrap-annotations page-break' },
        React.createElement("div", { className: "bg-transparent card-header py-0" },
            React.createElement("div", { className: "row header-card fs-4" }, t('annotations.title'))),
        React.createElement("table", { className: 'annotations-table table' },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("td", null, t('annotations.reported_on')),
                    React.createElement("td", null, t('annotations.reported')))),
            React.createElement("tbody", null, annotations.map(function (a, i) {
                return React.createElement("tr", { className: 'annotation-list-row', key: a.created_at },
                    React.createElement("td", { className: 'annotation-index grey-team fs-4' },
                        "#",
                        i),
                    React.createElement("td", null, moment(a.created_at).utc().format('MMM DD, YYYY, HH:mm')),
                    React.createElement("td", null, a.annotation_types.map(function (at) { return t("annotations.".concat(at)); }).join(', ')));
            })))));
}
export default AnnotationsList;
//# sourceMappingURL=annotations-list.js.map